/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Scheduled_DayInputs */

const en_orders_scheduled_day = /** @type {(inputs: Orders_Scheduled_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled Day`)
};

const es_orders_scheduled_day = /** @type {(inputs: Orders_Scheduled_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia programado`)
};

/**
* | output |
* | --- |
* | "Scheduled Day" |
*
* @param {Orders_Scheduled_DayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_scheduled_day = /** @type {((inputs?: Orders_Scheduled_DayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Scheduled_DayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_scheduled_day(inputs)
	return es_orders_scheduled_day(inputs)
});